import { RootState } from '../../../app/redux/store'; // Adjust path as per your project structure

export const selectOneSchemaToken = (state: RootState) =>
  state.dataOnboarding?.oneSchemaToken;
export const selectOneSchemaTokenLoading = (state: RootState) =>
  state.dataOnboarding?.loadingOneSchemaToken;
export const selectOneSchemaTokenError = (state: RootState) =>
  state.dataOnboarding?.oneSchemaTokenError;
